import React from 'react'
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';

import { HomeWrapper, HeroSection, Container, SectionsContainer, MapPlaceholder } from './home.styles';
import { InfoSection } from '../../components/info-section/info-section.component';

export const HomePage = () => {
  return (
    <HomeWrapper>
      <span className='mask bg-gradient-dark opacity-4'></span>

      {/* Hero Section */}
      <HeroSection>
        <Container>
          <div className='row justify-content-center'>
            <div className='col-lg-8 col-sm-9 text-center mx-auto'>
              <h1 className='text-white mb-6' spellCheck='false'>Nautic Club Daniela Cristina</h1>
              <p className='lead text-white'>
                Strada Marasesti, nr. 29, Snagov, Ghermanesti, Romania
              </p>

              <p className='lead text-white mb-sm-6 mb-4'>
                Telefon: <a className='text-white' href='tel:+40722230550'>+40 722 230 550</a>
              </p>

              <p className='text-white h6 text-uppercase mb-4'>Suntem si pe social media</p>

              <Box sx={{ mt: 2, maxWidth: '900px', mx: 'auto' }}>
                <Box sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                  gap: 2
                }}>
                  <a href='https://www.facebook.com/ncdcparkstorage' target='_blank' rel='noopener noreferrer nofollow' style={{ textDecoration: 'none' }}>
                    <Box sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                      }
                    }}>
                      <Typography sx={{ color: 'white', fontSize: '0.9rem', textAlign: 'center' }}>N C D C Park Storage Boats, Cars & Boat trailers, Snagov Ghermanesti</Typography>
                    </Box>
                  </a>
                  <a href='https://www.facebook.com/excursiicubarcaSharkDCpelaculSnagov' target='_blank' rel='noopener noreferrer nofollow' style={{ textDecoration: 'none' }}>
                    <Box sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                      }
                    }}>
                      <Typography sx={{ color: 'white', fontSize: '0.9rem', textAlign: 'center' }}>Excursii cu Barca Shark DC pe Lacul Snagov, Ilfov, Romania</Typography>
                    </Box>
                  </a>
                  <a href='https://www.facebook.com/profile.php?id=100065546227289' target='_blank' rel='noopener noreferrer nofollow' style={{ textDecoration: 'none' }}>
                    <Box sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                      }
                    }}>
                      <Typography sx={{ color: 'white', fontSize: '0.9rem', textAlign: 'center' }}>NCDC Snagov BOATS, RENT & TRIPS</Typography>
                    </Box>
                  </a>
                  <a href='https://www.facebook.com/profile.php?id=100063896811167' target='_blank' rel='noopener noreferrer nofollow' style={{ textDecoration: 'none' }}>
                    <Box sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                      }
                    }}>
                      <Typography sx={{ color: 'white', fontSize: '0.9rem', textAlign: 'center' }}>Cazare Ambarcatiuni si Skijeturi pe Lacul Snagov</Typography>
                    </Box>
                  </a>
                  <a href='https://www.facebook.com/profile.php?id=100065661004818' target='_blank' rel='noopener noreferrer nofollow' style={{ textDecoration: 'none' }}>
                    <Box sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                      }
                    }}>
                      <Typography sx={{ color: 'white', fontSize: '0.9rem', textAlign: 'center' }}>Excursii Cu Barca Pe Lacul Snagov</Typography>
                    </Box>
                  </a>
                  <a href='https://www.facebook.com/profile.php?id=100076004958956' target='_blank' rel='noopener noreferrer nofollow' style={{ textDecoration: 'none' }}>
                    <Box sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                      }
                    }}>
                      <Typography sx={{ color: 'white', fontSize: '0.9rem', textAlign: 'center' }}>Cu barca pe Lacul Snagov</Typography>
                    </Box>
                  </a>
                  <a href='https://www.facebook.com/profile.php?id=61557790985008' target='_blank' rel='noopener noreferrer nofollow' style={{ textDecoration: 'none' }}>
                    <Box sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                      }
                    }}>
                      <Typography sx={{ color: 'white', fontSize: '0.9rem', textAlign: 'center' }}>Plimbari Cu Barca Pe Lacul Snagov</Typography>
                    </Box>
                  </a>
                  <a href='https://www.facebook.com/profile.php?id=100090643216338' target='_blank' rel='noopener noreferrer nofollow' style={{ textDecoration: 'none' }}>
                    <Box sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      backdropFilter: 'blur(10px)',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      transition: 'all 0.3s',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
                      }
                    }}>
                      <Typography sx={{ color: 'white', fontSize: '0.9rem' }}>Cazare Ambarcatiuni la Snagov</Typography>
                    </Box>
                  </a>
                </Box>
              </Box>
            </div>
          </div>
        </Container>
      </HeroSection>

      {/* Info Sections */}
      
      {false && (
      <SectionsContainer>
        {/* Special Announcement 2026 */}
        <InfoSection
          title="👋🏻 VEȘTI PENTRU 2026 ❗️"
        >
          <Box sx={{ color: 'white' }}>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Cazare Ambarcatiuni si Skijeturi pe Lacul Snagov de la Nautic CLUB Daniela Cristina Snagov pastreaza preturile de baza si in 2026 🌞!
            </Typography>

            <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
              <Box sx={{
                backgroundColor: 'rgba(3, 169, 244, 0.3)',
                border: '1px solid rgba(3, 169, 244, 0.6)',
                borderRadius: '16px',
                padding: '4px 12px',
                display: 'inline-block'
              }}>
                <Typography variant="body2" sx={{ color: '#03a9f4', fontWeight: 'bold' }}>
                  #ncdcsnagov
                </Typography>
              </Box>
              <Box sx={{
                backgroundColor: 'rgba(3, 169, 244, 0.3)',
                border: '1px solid rgba(3, 169, 244, 0.6)',
                borderRadius: '16px',
                padding: '4px 12px',
                display: 'inline-block'
              }}>
                <Typography variant="body2" sx={{ color: '#03a9f4', fontWeight: 'bold' }}>
                  #snagov
                </Typography>
              </Box>
            </Box>

            <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', color: '#4caf50' }}>
              NU SCUMPIM NIMIC !
            </Typography>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#4caf50' }}>
              LISTELE DE PRET RAMAN LA FEL !
            </Typography>

            <Typography variant="h6" sx={{ mb: 3 }}>
              ☎️ 0722230550
            </Typography>

            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Nu uitati sa va rezervati locurile !
            </Typography>

            <Box sx={{ mt: 3, p: 2, backgroundColor: 'rgba(255, 193, 7, 0.2)', borderRadius: '8px' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#ffc107' }}>
                🌞Ps: GARANTAM PRETURILE ASTEA PENTRU CEI CE VIN IN APRILIE SI MAI 2026 ❗️ — la Cazare Ambarcatiuni si Skijeturi pe Lacul Snagov.
              </Typography>
            </Box>
          </Box>
        </InfoSection>

        {/* News 2026 Section */}
        <InfoSection
          title="🚤 ANUNȚ IMPORTANT - 2026 ❗"
        >
          <Box sx={{ color: 'white', mb: 3 }}>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              Toate bărcile care se lansează la apă sunt obligate să aibă baloanele de acostare montate încă de pe mal, minimum două pe fiecare parte. Recomandat: șase baloane.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              Deși la pontoane sunt montate apărători, pe apă bărcile sunt supuse mișcării cauzate de valuri și de traficul altor ambarcațiuni.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              În lipsa baloanelor de acostare montate înainte de lansarea la apă, nu ne asumăm nicio răspundere pentru eventualele avarii produse ulterior. Barca trebuie să fie echipată corespunzător cu minimum 4–6 baloane de acostare.
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Baloanele de acostare trebuie să aibă dimensiuni adecvate, astfel încât să prevină lovirea bărcilor între ele sau de pontoane, în condiții de valuri sau vânt.
            </Typography>

            {/* Horizontal Divider */}
            <Box sx={{ my: 4, borderTop: '2px solid rgba(255, 255, 255, 0.2)' }} />

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
              📌 Câteva anunțuri importante pentru sezonul 2026 peste listele de prețuri afișate, așa cum v-am mai anunțat:
            </Typography>

            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8 }}>
              📍 1. Dacă sunt mai mulți proprietari pe un bun (barcă, jet) se adaugă 100 lei/lună la fiecare coproprietar pentru fiecare bun.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8 }}>
              📍 2. Sta la noi pontonul de jet doar vara, prețul este de 200 lei/lună depozitarea, iar prețul pentru staționare jet este cel din listă.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8 }}>
              📍 3. Dai barca sau skijetul altcuiva decât celui care e trecut în factură, se va face tot cu telefon în prealabil, dar de fiecare dată pentru serviciul acesta se adună la factură 100 lei/operațiune.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8 }}>
              📍 4. Pentru fiecare barcă sau skijet parcat(e) la noi ai inclus pe perioada cât te plimbi cu ele un loc de parcare pentru un auto, exclus dube, restul (musafirii) se achită parcare și costul este de 20 lei/oră sau 50 lei/zi (10:00 până la apus).
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.8 }}>
              📍 5. Vrei să alimentezi barca, te ajutăm cu canistre omologate; să mergi tu să îți iei și să o transferăm în barcă – 10 lei/canistră de 20 litri, sau putem face noi asta cu autoutilitara noastră, iar pentru fiecare între 0–100 litri plătești transport și manevrare 100 lei.
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, lineHeight: 1.8 }}>
              📍 6. La pachetele de peste 3 luni pentru jeturi, periodic-ul e inclus în prețul din listă.
            </Typography>

            <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 2 }}>
              Toate acestea fiind de achitat la casa de marcat sau se facturează în contul și pe numele proprietarului la sfârșit de lună ❗
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              📞 072223055
            </Typography>
          </Box>
          <MapPlaceholder>
            <img src="https://imagedelivery.net/Z5lEYwq8x5HYlOcAYUT42Q/ee48ee3b-4750-48f3-4a14-4857a007da00/public" alt="Nautic Club Daniela Cristina" />
          </MapPlaceholder>
        </InfoSection>

        {/* Packages & Pricing Section */}
        <InfoSection
          title="⚓ PREȚURI CAZARE AMBARCAȚIUNI 2026"
        >
          <Box sx={{ color: 'white' }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>🚤 PACHET minim 2 luni</Typography>
              <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>💰 140 lei / ml / lună</Typography>
              <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>+15 lei / ml / lună (iunie–septembrie)</Typography>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>🚤 PACHET 3–5 luni</Typography>
              <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>💰 125 lei / ml / lună</Typography>
              <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>+15 lei / ml / lună (iunie–septembrie)</Typography>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>🚤 PACHET 6–8 luni</Typography>
              <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>💰 115 lei / ml / lună</Typography>
              <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>+15 lei / ml / lună (iunie–septembrie)</Typography>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>🚤 PACHET 1 AN</Typography>
              <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>💰 100 lei / ml / lună</Typography>
              <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>➕ Parcare peridoc (preț neschimbat de 12 ani)</Typography>
              <Typography variant="body2" sx={{ mb: 3, pl: 2, color: '#4caf50', fontWeight: 'bold' }}>✨ NOU!</Typography>
            </Box>

            <Box sx={{ mt: 4, p: 2, backgroundColor: 'rgba(255, 255, 255, 0.05)', borderRadius: '8px' }}>
              <Typography variant="body2" sx={{ mb: 2 }}>
                📌 Pentru a beneficia de aceste prețuri, pachetul trebuie ales fix pentru perioada pentru care chiriașul este dispus să plătească în avans:
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, pl: 2 }}>
                👉 2 luni | 3–5 luni | 6–8 luni | 1 an
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                💳 Plata se poate face, ca și până acum, din 3 în 3 luni
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, color: '#f44336', fontWeight: 'bold' }}>
                ⚠️ Orice întârziere la plată atrage o penalitate de 500 lei / lună
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                👥 Cei care nu au peridoc sau nu îl lasă la noi vor plăti:
              </Typography>
              <Typography variant="body2" sx={{ mb: 2, pl: 2, color: '#ff9800', fontWeight: 'bold' }}>
                ➕ 50 lei / lună – taxă membru club
              </Typography>
            </Box>
          </Box>
        </InfoSection>

        {/* Services 2026 Section - Merged */}
        <InfoSection
          title="Servicii pentru 2026"
        >
          <Box sx={{ color: 'white' }}>
            {/* Boat Launch Services */}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
              RAMPA DE LANSARE -RIDICARE AUTORIZATA PE CARE LOCATIA O DETINE
            </Typography>

            <Typography variant="h6" sx={{ mb: 2 }}>Pentru barci cu masina clientului sunt:</Typography>
            <TableContainer component={Paper} sx={{ mb: 4, backgroundColor: 'rgba(255, 255, 255, 0.05)' }}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>Până în 750 kg</TableCell>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>60 lei/operațiune</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>751 kg - 1250 kg</TableCell>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>80 lei/operațiune</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>1251 kg - 2000 kg</TableCell>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>100 lei/operațiune</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>2001 kg - 3000 kg</TableCell>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>150 lei/operațiune</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>3001 kg - 4000 kg</TableCell>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>250 lei/operațiune</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>4001 kg - 7 tone</TableCell>
                    <TableCell sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>550 lei/operațiune</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            {/* Horizontal Divider */}
            <Box sx={{ my: 4, borderTop: '2px solid rgba(255, 255, 255, 0.2)' }} />

            {/* Jet Ski Services */}
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
              PRETURI SERVICII CAZARE PENTRU SKIJETURI
            </Typography>
            <Typography variant="h6" sx={{ mb: 3 }}>
              PE 2026 la Nautic CLUB Daniela Cristina
            </Typography>

            <Typography variant="h6" sx={{ mb: 2 }}>🟦 Skijeturi de 3 locuri si peste 130 cp</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>5-6 luni 500 lei/luna ,</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>3 -5 luni 550 lei /luna</Typography>
            <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>1 luna 600 lei /luna</Typography>

            <Typography variant="h6" sx={{ mb: 2 }}>🟦 Pentru skijeturi de 2 locuri si sub 130 cp si Spark</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>5-6 luni 400 lei /luna</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>3-5 luni 450 lei /luna</Typography>
            <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>1 luna 500 lei /luna</Typography>

            <Typography variant="body2" sx={{ mb: 3, fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.8)' }}>
              Peridocul poate ramane pretul este acelasi cu sau fara peridoc ramas la noi .
            </Typography>

            <Typography variant="h6" sx={{ mb: 2 }}>
              ✅ Serviciille pentru RAMPA DE LANSARE-RIDICARE AUTORIZATA
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              PE CARE LOCATIA O DETINE la skijeturi sunt:
            </Typography>
            <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>
              50 bagat /50 scos si daca se plateste serviciul de cazare in avans pe pachetul de minim 3 luni rampa gratis cu masina clientului ori de cate ori are nevoie in perioada platita
            </Typography>

            <Typography variant="h6" sx={{ mb: 2 }}>✨ PONTOANE CUBURI - pentru skijet</Typography>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>PRET DEPOZITARE</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>150 lei /luna APRILIE-OCTOMBRIE</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>75 lei /luna NOIEMBRIE-MARTIE</Typography>
            <Typography variant="body2" sx={{ mb: 3, pl: 2, fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.8)' }}>
              ( pentru alte modele pretul se dubleaza)
            </Typography>

            <Box sx={{ mt: 3, p: 2, backgroundColor: 'rgba(244, 67, 54, 0.2)', borderRadius: '8px' }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                ⚠️ ÎNTÂRZIEREA LA PLATA DUCE LA O PENALITATE DE 250 lei ÎN PLUS PE FIECARE LUNA FACTURATA SI NEACHITATA.
              </Typography>
            </Box>

            {/* Horizontal Divider */}
            <Box sx={{ my: 4, borderTop: '2px solid rgba(255, 255, 255, 0.2)' }} />

            {/* Trailer Parking Content */}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
              🟥 PRETURI PARCARE PERIDOCURI 2026
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.8)' }}>
              La NCDC Park Storage Boats, Cars & Boat trailers, Snagov Ghermanesti
            </Typography>

            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>✅ 100 lei/luna pentru peridoc skijet simplu</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>✅ 150 lei/luna pentru peridic skijet dublu</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>✅ 125 lei/luna O AXA PANA IN 750 kg  MMA</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>✅ 150lei/luna O AXA INTRE 751-1500kg MMA</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>✅ 200lei/luna doua axe sau intre 1500 kg MMA si 2500 kg MMA</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>✅ 250 lei/luna  DOUA AXE INTRE 2501 si 3500kg MMA</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>✅ 300 lei /luna trei axe pana in 3500 MMA</Typography>
            <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>✅ 400 lei /luna TREI AXE INTRE 3501 si 5000 kg MMA</Typography>
            <Typography variant="body2" sx={{ mb: 2, fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.8)' }}>
              (PENTRU PACHETELE DE 1 AN PRETUL SCADE CU 50 lei/luna la fiecare pachet) LISTA DE PRETURI
            </Typography>

            {/* Horizontal Divider */}
            <Box sx={{ my: 4, borderTop: '2px solid rgba(255, 255, 255, 0.2)' }} />

            {/* NOU LA NCDC PARK STORAGE */}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
              NOU LA NCDC PARK STORAGE
            </Typography>

            <Typography variant="h6" sx={{ mb: 2 }}>📌 Abonamente peridocuri + barcă pe peridoc:</Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>* Barca până în 6 ml + peridoc simplu</Typography>
            <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>👉 500 lei/lună</Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>* Pentru fiecare metru în plus peste 6 ml</Typography>
            <Typography variant="body2" sx={{ mb: 3, pl: 2 }}>👉 +75 lei/ml/lună</Typography>

            <Box sx={{ my: 3, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }} />

            <Typography variant="h6" sx={{ mb: 2 }}>📌 Dacă vrei să ții doar peridocul la noi (fără barcă):</Typography>

            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>* Până în 6 m 👉 300 lei/lună</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>* 7 m 👉 400 lei/lună</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>* 8 m 👉 500 lei/lună</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>* 9 m 👉 550 lei/lună</Typography>
            <Typography variant="body2" sx={{ mb: 1, pl: 2 }}>* 10 m 👉 600 lei/lună</Typography>
            <Typography variant="body2" sx={{ mb: 3, pl: 2, fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.8)' }}>
              (maxim 2,5 m lățime)
            </Typography>

            <Box sx={{ my: 3, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }} />

            <Typography variant="body2" sx={{ mb: 2 }}>
              ✅ Locație autorizată, cu siguranță garantată pentru barca și peridocul tău!
            </Typography>

            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              ✅ Se masoara de la cupla de prindere pana in spatele barcii/peridocului , ultimul punc
            </Typography>
          </Box>
        </InfoSection>
      </SectionsContainer>
      )}
    </HomeWrapper>
  )
}
